export enum TAG {
  GROUP_LOGO = 'GroupLogo',
  GROUP_MANAGER = 'GroupManager',
  USER_PROFILE = 'UserProfile',
  COMPANY_LIST = 'CompanyList',
  DASHBOARD_LIST = 'DashboardList',
  DASHBOARD_REPORT_CHART = 'DashboardReportChart',
  CATEGORY_LIST = 'CategoryList',
  ARTICLES = 'Article',
  ARTICLE_LIST = 'ArticleList',
  USER_ARTICLE_LIST = 'UserArticleList',
  ARTICLES_SEARCH = 'ArticlesSearch',
  TOPIC_LIST = 'TopicList',
  CLIENT_CONFIGURATION = 'ClientConfiguration',
  CLIENT_TYPE = 'ClientType',
  PRODUCT = 'Product',
}
